import script from "./LocationList.vue?vue&type=script&setup=true&lang=js"
export * from "./LocationList.vue?vue&type=script&setup=true&lang=js"

import "./LocationList.vue?vue&type=style&index=0&id=01c84cc7&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-01c84cc7"]])

export default __exports__